export default __webpack_public_path__ + "static/footer_cv_sp-915a080f200de566482aa0ddf27d66d8.png";